import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Card({ title, footer, children, style, ...rest }) {
    return (_jsxs("section", { style: {
            background: "var(--hydrax-color-surface)",
            color: "var(--hydrax-color-text)",
            border: "1px solid var(--hydrax-color-border)",
            borderRadius: "var(--hydrax-radius-md)",
            padding: 16,
            fontFamily: "var(--hydrax-font-sans)",
            ...style,
        }, ...rest, children: [title ? (_jsx("header", { style: { marginBottom: 12, fontWeight: 600 }, children: title })) : null, _jsx("div", { children: children }), footer ? (_jsx("footer", { style: { marginTop: 12, color: "var(--hydrax-color-text-muted)" }, children: footer })) : null] }));
}
//# sourceMappingURL=Card.js.map